import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import InputLabel from '../atoms/labels/InputLabel';
import ErrorLabel from '../atoms/labels/ErrorLabel';
import FilterInput from '../atoms/FilterInput';
import InputClearButton from '../atoms/InputClearButton';
import { uniqueId } from 'lodash';
const OuterWrapper = styled.div `
    position: relative;
    margin-bottom: 20px;
    margin-right: 20px;
    width: ${props => (props.width ? props.width : 'auto')};

    &:last-child {
        margin-right: 0;
    }

    &:first-child&:last-child {
        margin: 0;
    }
`;
const FilterInputItem = ({ id, label, error, width, name, value, setFilter, ...props }) => {
    const [fieldId] = useState(id || uniqueId);
    const onChange = (e) => {
        setFilter(e.target.name, e.target.value);
    };
    return (_jsxs(OuterWrapper, { width: width, children: [_jsx(InputLabel, { marginBottom: "6px", htmlFor: fieldId, activeFilter: !!value, children: label }), _jsx(FilterInput, { id: fieldId, name: name, value: value || '', activeFilter: !!value, onChange: onChange, ...props }), value && _jsx(InputClearButton, { onClick: () => setFilter(name, '') }), error && _jsx(ErrorLabel, { children: error })] }));
};
export default FilterInputItem;
